import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';


export const getAllScheduleOrders = createAsyncThunk(
    'schedule/getAllScheduleOrders',
    async (config, { dispatch, rejectWithValue }) => {
        try {

            console.log(config, 'config')
            const searchParams = new URLSearchParams(config).toString()

            const { data, status } = await api.getAllScheduledOrder(searchParams);

           

            return data
            //   console.log(response.data?.data);
        } catch (error) {
            console.log(error);
        }
    }
);

export const getScheduleOrdersStatistics = createAsyncThunk(
    'schedule/getScheduleOrdersStatistics',
    async (config, { dispatch, rejectWithValue }) => {
        try {
            const { data, status } = await api.getScheduleOrderStatistics();

            if (status === 200) {
                dispatch(setScheduledOrderStatistics(data.data))
            }

            return data.data
            //   console.log(response.data?.data);
        } catch (error) {
            console.log(error);
        }
    }
);



const scheduleOrderSlice = createSlice({
    name: 'scheduleOrder',
    initialState: {
        scheduleOrders: [],
        scheduleOrderDetails: {},
        scheduleOrdertatistics: {
            data: {},
            loading: false
        },
        refresh: false,
        loading: false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        filters: {
            page: 1,
            search: '',
            status: '',
            fromDate: '',
            toDate: '',
        },
        page: 1,
        search: "",
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setschedulerefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setScheduledOrders: (state, action) => {
            state.scheduleOrders = action.payload
        },
        setScheduledOrderStatistics: (state, action) => {
            state.scheduleOrdertatistics.data = action.payload;
        },
        setFilterValues: (state, action) => {
            state.filters = { ...state.filters, ...action.payload }
        },
        setScheduleOrderTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setScheduleOrderPage: (state, action) => {
            state.page = action.payload
        },
        setScheduleSearch: (state, action) => {
            state.search = action.payload
        },
        setScheduleOrderFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setScheduleOrderToDate: (state, action) => {
            state.toDate = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllScheduleOrders.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllScheduleOrders.fulfilled, (state, action) => {
                state.loading = false;
                state.scheduleOrders = action.payload;
            })
            .addCase(getAllScheduleOrders.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export const {
    setScheduledOrders,
    setScheduledOrderStatistics,
    setFilterValues,
    setScheduleOrderTab,
    setScheduleSearch,
    setScheduleOrderPage,
    setScheduleOrderFromDate,
    setScheduleOrderToDate,
    setschedulerefresh
} = scheduleOrderSlice.actions

export default scheduleOrderSlice.reducer;
